<template>
  <div class="center">
    <h3>Authentification</h3>
    <p>In development..</p>
  </div>
</template>

<script>
export default {
  name: "AuthentificationForm",
};
</script>

<style lang="scss" scoped>
.center {
  padding-left: calc(50% - 580px);
  padding-right: calc(50% - 580px);
}
</style>
